/* eslint-disable no-unused-vars */
export enum ERegionCode {
  SA = "sa",
}
export enum ECarrierCode {
  SA = "996",
}
